module.exports = __webpack_public_path__ + "img/python.54651a83.svg";